import { render, staticRenderFns } from "./ContentSliderComponent.vue?vue&type=template&id=688897a4&scoped=true"
import script from "./ContentSliderComponent.vue?vue&type=script&lang=js"
export * from "./ContentSliderComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentSliderComponent.vue?vue&type=style&index=0&id=688897a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688897a4",
  null
  
)

export default component.exports